// ANCHOR React
import { ReactNode } from 'react';

// ANCHOR Base
import { Block } from 'baseui/block';
import { LabelLarge } from 'baseui/typography';

// ANCHOR Constants
import { DEFAULT_LABELS } from './constants';

// ANCHOR Styles
import { BLOCK, PARAGRAPH } from './styles';

interface IProps {
  type: 'default' | 'event' | 'thumbnail' | 'course',
  label?: string;
  actionButton?: ReactNode;
}

export function LyonEmptyStateInfo({ type, label, actionButton }: IProps) {
  return (
    <Block overrides={BLOCK}>
      <LabelLarge overrides={PARAGRAPH}>
        {label || DEFAULT_LABELS[type]}
      </LabelLarge>
      {actionButton}
    </Block>
  );
}
